
import * as ConfigTypes from 'config/ConfigTypes';
import { pubPath } from 'helpers/AppHelper';


export const getMfxInfoFromSourcefile = ({ mediaTypeObj, mediafiles }) => {
    if (mediaTypeObj && mediaTypeObj.curMediafile
        && mediaTypeObj.curMediafile.tags
    ) {
        if (mediafiles && mediafiles.elements && mediafiles.elements.length > 0) {
            let tags = mediaTypeObj.curMediafile.tags;
            let exists = mediafiles.elements
                .find(item => {
                    if (item.filename) {
                        let fname = item.data.filename.split('.')[0]
                        if (item.data && item.data.sourcefile && tags.includes(`priref_${fname}`)) {
                            return item;
                        }
                    }
                    return false;
                });
            if (exists && exists.data) {
                let dimension = '';
                if (exists.data.width && exists.data.height) {
                    dimension = `${exists.data.width}x${exists.data.height}px`;
                }
                return {
                    dimension,
                    colorspace: exists.data.colorspace || '',
                    format: exists.data.containerformat || ''
                }
            }
        }
    }
    return null;
}

export const getDefaultImg = () => {
    let random = Math.ceil(Math.random() * 5);
    //let imgSrc = `${pubPath()}/thumbnails/DK_Website_Personenarchiv_Platzhalter_0${random}.jpg`;
    let imgSrc = `${pubPath()}/thumbnails/DK_Website_Personenarchiv_Platzhalter_02.jpg`;
    return imgSrc;
}

const getBlobFromUrl = (mediaUrl) => {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        request.open('GET', mediaUrl, true);
        request.responseType = 'blob';
        request.onload = () => {
            resolve(request.response);
        };
        request.onerror = reject;
        request.send();
    })
}

export const convertUrlToMediaData = async (mediaUrl) => {
    try {
        let mediaBlob = await getBlobFromUrl(mediaUrl);
        return mediaBlob;
    } catch (err) {
        console.log("CONVERT FILE ERROR: ", err);
        return null;
    }
}

export const getMediaUrl = (elements, clip, type) => {
    let mediaUrl = "";
    if (clip && elements && elements.length) {
        console.log("LOGS: getMediaUrl clip", clip);
        console.log("LOGS: getMediaUrl elements", elements);
        let pattern = /.mp4$/i;
        mediaUrl = elements[0].url;
        let isType = (clip && clip.media && clip.media.fields && clip.media.fields[type]) ? true : false;
        //LAMTEST if (isAudio()) pattern = /.mp3$|.mp4$|.wav$|.aac$/i;
        let obj = elements.find(item => (isType && item.data.tags && item.data.tags.includes("preview")));
        if (!obj) obj = elements.find(item => (item.data.url.search(pattern) > -1 && item.data.tags && item.data.tags.includes("preview")));
        if (!obj) obj = elements.find(item => (item.data.url.search(pattern) > -1 && item.data.sourcefile));
        if (!obj) obj = elements.find(item => (item.data.url.search(pattern) > -1));
        if (obj && obj.url) {
            if (obj.url.startsWith("//")) mediaUrl = "https:" + obj.url;
            else mediaUrl = obj.url;
        }
    }
    return mediaUrl;
}


export const setUrl = (obj) => {
    let mediaUrl;
    if (obj && obj.url) {
        if (obj.url.startsWith("//")) mediaUrl = "https:" + obj.url;
        else mediaUrl = obj.url;
    }

    return mediaUrl;
}

export const getMediaTypeObj = ({ elements, clip }) => {
    let imgObj = { type: ConfigTypes.IMAGE };
    if (clip && elements && elements.length) {
        console.log("LOGS: getMediaTypeObj clip", clip);
        console.log("LOGS: getMediaTypeObj elements", elements);
        let videoPattern = /.mp4$|.mov$|.flv$/i;
        let imgPattern = /.jpg$|.jpeg$|.png$/i
        let videoObj = { type: ConfigTypes.VIDEO };
        if (clip.thumbnail) {
            videoObj.thumbnail = clip.thumbnail;
            imgObj.thumbnail = clip.thumbnail;
        }
        if (clip.videourl) {
            videoObj.mediaUrl = clip.videourl;
            return videoObj;
        }
        let obj = elements.find(item => (item.data.url.search(videoPattern) > -1
            && item.data.tags && item.data.tags.includes("preview")));
        if (obj) {
            videoObj.mediaUrl = setUrl(obj);
            return videoObj;
        }
        if (!obj) obj = elements.find(item => (item.data.url.search(imgPattern) > -1 && item.data.tags && item.data.tags.includes("preview")));
        if (obj) {
            imgObj.mediaUrl = setUrl(obj);
            imgObj.curMediafile = obj;
            return imgObj;
        }
        if (!obj) obj = elements.find(item => (item.data.url.search(videoPattern) > -1 && item.data.sourcefile));
        if (obj) {
            videoObj.mediaUrl = setUrl(obj);
            return videoObj;
        }
        if (!obj) {
            obj = elements.find(item => (item.data.url.search(imgPattern) > -1 && item.data.sourcefile));
            imgObj.curMediafile = obj;
        }
        if (obj) {
            imgObj.mediaUrl = setUrl(obj);
            imgObj.curMediafile = obj;
            return imgObj;
        }
    }

    if (clip.mainthumbnail && clip.mainthumbnail.url) {
        imgObj.mediaUrl = `${clip.mainthumbnail.url}&width=${ConfigTypes.IMG_WIDTH}&height=${ConfigTypes.IMG_HEIGHT}`;
        console.log("LOGS: FileHelper clip.mainthumbnail", imgObj.mediaUrl);
        return imgObj;
    }

    return { mediaUrl: getDefaultImg(), type: ConfigTypes.DEFAULT };

}

export const convertSrtToVtt = (subLg) => () => {
    console.log("LOGS: convertSrtToVtt  subLg", subLg);
    let tracks = document.querySelectorAll("track");
    let subtitle = {
        data:
        {
            track: {}
        },
        load: function (track) {
            subtitle.track = track;

            if (subtitle.isSrt(subtitle.track.src)) {
                let client = new XMLHttpRequest();
                client.open('GET', subtitle.track.src);
                client.onreadystatechange = function () {
                    subtitle.convert(client.responseText).then(
                        function (file) {
                            subtitle.track.src = file
                        }
                    );
                }
                client.send();
            }
        },

        convert: function (content) {
            let promise = new Promise(
                function (resolve, reject) {
                    content = content.replace(/(\d+:\d+:\d+)+,(\d+)/g, '$1.$2');
                    if (!content.includes("WEBVTT")) content = 'WEBVTT' + content;
                    let blob = new Blob([content], { type: 'text/vtt' });
                    let file = window.URL.createObjectURL(blob);
                    resolve(file);
                }
            );

            return promise;
        },
        isSrt: function (filename) {
            return filename.split('.').pop().toLowerCase() === 'srt' ? true : false;
        },
        isVTT: function (filename) {
            return filename.split('.').pop().toLowerCase() === 'vtt' ? true : false;
        }
    }

    for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].getAttribute("srclang") == subLg) {
            subtitle.load(tracks[i]);
        }
    }
}

